// CompanySelect.jsx
import React, { useEffect, useState } from "react";
import { Select, MenuItem } from "@mui/material";

const AccessLevelSelect = ({ value, onChange, label = "Access Level", ...props }) => {

  const [selectedValue, setSelectedValue] = useState(value.split(':')[1]);
  const handleSelect = (e) => {
    setSelectedValue(e.target.value);
    onChange(`${value.split(':')[0]}:${e.target.value}`);
  };

  const [levels, setLevels] = useState([
    {id: 0, label: 'Blocked'},
    {id: 1, label: 'View Only'},
    {id: 2, label: 'View, Create, Edit'},
    {id: 3, label: 'View, Create, Edit, Delete'},
  ]);


  return (
    
        <Select value={selectedValue} onChange={handleSelect} label={label} size="small" variant="standard" fullWidth>
          {levels.map((level) => (
            <MenuItem 
              key={level.id} 
              value={level.id}
            >
              {level.label}
            </MenuItem>
          ))}
        </Select>
  );
};

export default AccessLevelSelect;